<template>
  <div>
    <canvas :id="idCanva"></canvas>
    <LoadingCover spinner="dotsbar" v-show="loading" />
  </div>
</template>
<script>
  import moment from "moment";
  import { uuid } from "vue-uuid";
  import { Chart, registerables } from "chart.js";
  import ChartDataLabels from "chartjs-plugin-datalabels";
  import { formatter } from "@/general";
  import CONSTANTS from "@/constants";
  import { dataCostoVentasDocumentos } from "@/apiData";

  import LoadingCover from "@/components/containers/LoadingCover.vue";

  Chart.register(...registerables)

  export default {
    name: "SalesRankingChart",
    data() {
      return {
        moment,
        uuid,
        formatter,
        loading: false,
        idCanva: "",
        colorsLabels: [
          CONSTANTS.colors.color01,
          CONSTANTS.colors.color02,
          CONSTANTS.colors.color03,
          CONSTANTS.colors.color05,
          CONSTANTS.colors.color07,
          CONSTANTS.colors.color08,
          CONSTANTS.colors.color10
        ],
        dataSalesCosts: []
      }
    },
    props: {
      title: String,
      initialDate: String,
      finalDate: String,
      reportType: String,
      utilityType: String,
      idCity: String,
      idBranch: String,
      idEmployeeGroup: String,
      idEmployee: String,
      orderBy: String,
      valuesDivisor: Number,
      valuesSing: String
    },
    components: {
      LoadingCover
    },
    methods: {
      async getDataSalesRanking() {
        try {
          const parameters = {
            "Fecha_Inicial": this.initialDate,
            "Fecha_Final": this.finalDate,
            "Tipo_Reporte": this.reportType,
            "Tipo_Utilidad": this.utilityType,
            "Id_Ciudad": this.idCity,
            "Id_Sucursal": this.idBranch,
            "Id_GrupoPersonal": this.idEmployeeGroup,
            "Id_Personal": this.idEmployee,
            "Orden": this.orderBy
          }
          const { response } = await dataCostoVentasDocumentos(this, parameters);
          this.dataSalesCosts = this.processTop(response, 10);
        } catch (error) {
          console.log(error)          
        }
      },
      processTop(data, top) {
        const dataTopIni = data.slice(0, top);
        const dataOthers = data.slice(top + 1, data.length);

        if (dataOthers.length === 0) {
          return dataTopIni;
        }

        const othersValues = dataOthers.reduce((totalizator, item) => {
          return {
            Descripcion: "Otros",
            Valor_Mercancia: totalizator.Valor_Mercancia + (item.Valor_Mercancia || 0),
            Valor_Utilidad: totalizator.Valor_Utilidad + (item.Valor_Utilidad || 0)
          }
        }, 
        { 
          Descripcion: "Otros", 
          Valor_Mercancia: 0, 
          Valor_Utilidad: 0
        });

        return [...dataTopIni, othersValues];
      },
      setupChart() {
        let optionsChart = {
          responsive: true,
          maintainAspectRadio: false,
          interaction: {
            mode: "index",
            intersect: false
          },
          scales: {
            x: {
              offset: true,
              grid: {
                display: false
              }
            }
          },
          plugins: {
            title: {
              display: true,
              text: this.title
            },
            legend: {
              display: true,
              position: "top",
              labels: {
                boxWidth: 5,
                boxHeight: 5
              }
            },
            tooltip: {
              enabled: true,
              position: "nearest",
              usePointStyle: true,
              padding: 12,
              borderwidth: 1,
              backgroundColor: "midnightblue",
              callbacks: {
                label : function (context) {
                  return [context.dataset.label, "$" + context.formattedValue] + "M";
                }
              }
            },
            datalabels: {
              formatter: (value) => {
                let sum = 0
                this.dataSalesCosts.map(data => sum += (data.Valor_Mercancia / this.valuesDivisor))
                let percentage = ((value * 100) / sum).toFixed(2)

                return `${percentage}%`
              }
            }
          }
        }

        // const images = [];

        const chart = new Chart(document.getElementById(this.idCanva), {
          type: "bar",
          data: {
            labels: this.dataSalesCosts.map(data => data.Descripcion),
            datasets: [
              {
                type: "bar",
                label: "Ventas",
                data: this.dataSalesCosts.map(data => Math.round((data.Valor_Mercancia / this.valuesDivisor) * 100) / 100 ),
                fill: false,
                borderColor: this.colorsLabels[2],
                backgroundColor: this.colorsLabels[2],
                datalabels: {
                  display: true,
                  anchor: "end",
                  align: "top"
                }
              },
              {
                type: "bar",
                label: "Utilidad",
                data: this.dataSalesCosts.map(data => Math.round((data.Valor_Utilidad / this.valuesDivisor) * 100) / 100),
                fill: false,
                borderColor: this.colorsLabels[1],
                backgroundColor: this.colorsLabels[1],
                datalabels: {
                  display: false
                }
              }
            ]
          },
          options: optionsChart,
          plugins: [
            ChartDataLabels,
            // {
            //   afterDraw: chart => {
            //     var ctx = chart.chart.ctx;
            //     var xAxis = chart.scales["x-axis-0"];
            //     var yAxis = chart.scales["y-axis-0"];
  
            //     xAxis.ticks.forEach((value, index) => {
            //       var x = xAxis.getPixelForTick(index);
            //       ctx.drawImage(images[index], x - 12, yAxis.bottom + 10);
            //     });
            //   }
            // }
          ]
        });

        chart.update();
      }
    },
    async mounted() {
      this.loading = true;

      try {
        this.idCanva = uuid.v1();

        await this.getDataSalesRanking();
        this.setupChart();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    }
  }
</script>
